__webpack_require__.p = "/app/themes/spiriit-servisud/dist/";